import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./emoji-font.css";
import * as serviceWorker from "./serviceWorker";

// Comprehensive ResizeObserver error suppression and fix
// This is a common issue with complex UI components and is generally safe to ignore

// Create a safer ResizeObserver wrapper
if (window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class SafeResizeObserver extends (
    OriginalResizeObserver
  ) {
    constructor(callback) {
      const safeCallback = (entries, observer) => {
        try {
          // Use requestAnimationFrame to prevent loop limit exceeded errors
          window.requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (error) {
              if (
                error.message &&
                (error.message.includes("ResizeObserver loop limit exceeded") ||
                  error.message.includes(
                    "ResizeObserver loop completed with undelivered notifications",
                  ))
              ) {
                // Silently ignore ResizeObserver loop errors
                return;
              }
              throw error;
            }
          });
        } catch (error) {
          if (
            error.message &&
            (error.message.includes("ResizeObserver loop limit exceeded") ||
              error.message.includes(
                "ResizeObserver loop completed with undelivered notifications",
              ))
          ) {
            // Silently ignore ResizeObserver loop errors
            return;
          }
          throw error;
        }
      };

      super(safeCallback);
    }
  };
}

// Suppress ResizeObserver console errors
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args[0] &&
    typeof args[0] === "string" &&
    (args[0].includes("ResizeObserver loop limit exceeded") ||
      args[0].includes(
        "ResizeObserver loop completed with undelivered notifications",
      ))
  ) {
    return; // Suppress ResizeObserver errors
  }
  originalConsoleError.apply(console, args);
};

// Handle window errors
const resizeObserverErrorHandler = (e) => {
  if (
    e.message &&
    (e.message.includes("ResizeObserver loop limit exceeded") ||
      e.message.includes(
        "ResizeObserver loop completed with undelivered notifications",
      ))
  ) {
    const resizeObserverErrDiv = document.getElementById(
      "webpack-dev-server-client-overlay-div",
    );
    const resizeObserverErr = document.getElementById(
      "webpack-dev-server-client-overlay",
    );
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute("style", "display: none");
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute("style", "display: none");
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
};

// Handle unhandled promise rejections (for async ResizeObserver errors)
const resizeObserverRejectionHandler = (e) => {
  if (
    e.reason &&
    e.reason.message &&
    (e.reason.message.includes("ResizeObserver loop limit exceeded") ||
      e.reason.message.includes(
        "ResizeObserver loop completed with undelivered notifications",
      ))
  ) {
    e.preventDefault();
    return false;
  }
};

// Add event listeners
window.addEventListener("error", resizeObserverErrorHandler);
window.addEventListener("unhandledrejection", resizeObserverRejectionHandler);

// Additional suppression for React error boundaries
const originalReactError = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
if (originalReactError) {
  const originalOnError = originalReactError.onCommitFiberRoot;
  if (originalOnError) {
    originalReactError.onCommitFiberRoot = (...args) => {
      try {
        return originalOnError.apply(originalReactError, args);
      } catch (error) {
        if (
          error.message &&
          (error.message.includes("ResizeObserver loop limit exceeded") ||
            error.message.includes(
              "ResizeObserver loop completed with undelivered notifications",
            ))
        ) {
          return; // Suppress ResizeObserver errors in React DevTools
        }
        throw error;
      }
    };
  }
}

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
